import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatCommissionAmount } from "@/lib/affiliateDashboard";
import type { PayoutRow } from "./useAffiliateDashboardData";

export function PayoutHistoryCard({ payouts }: { payouts: PayoutRow[] }) {
  if (payouts.length === 0) return null;
  return (
    <Card className="shadow-soft">
      <CardHeader>
        <CardTitle className="text-base">Payout history</CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="divide-y divide-border text-sm">
          {payouts.map((p) => (
            <li key={p.id} className="flex items-center justify-between gap-3 py-2">
              <div>
                <div className="font-medium">
                  {formatCommissionAmount(p.total_amount_cents, p.currency)}
                </div>
                <div className="text-xs text-muted-foreground">
                  {new Date(p.paid_at).toLocaleDateString()} · {p.commission_count} commission(s)
                  {p.payment_reference ? ` · ref ${p.payment_reference}` : ""}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
